import React from "react";
import { Content } from "../components/Content";
import { useWalletAssets } from "../hooks/useWalletAssets";

export const GoldCoin = () => {
  const { boxes } = useWalletAssets(3);

  return (
    <div className="px-4 sm:px-6 md:px-10">
      <Content boxes={boxes} id={16} pageName="سکه" />
    </div>
  );
};
